module.exports = __webpack_public_path__ + "media/images/eyecatch-cm-sm-23f14468f33846742aebf8d7b1279b27.jpg";